import { useLegStore } from "../store/legStore";
import { Button } from "./Button";

/**
 * Surfaces legStore.error.
 *
 * Leg mutations are optimistic with rollback, so a failure otherwise reads as
 * the change silently undoing itself — a place dropped on a leg bar flashes in
 * and vanishes. A dismissible banner is deliberate rather than a modal: the
 * rollback already restored a consistent state, so nothing is blocked.
 */
export function LegErrorNotice() {
  const error = useLegStore((state) => state.error);
  const clearError = useLegStore((state) => state.clearError);

  if (!error) return null;

  return (
    <div
      role="status"
      className="fixed bottom-4 left-1/2 z-50 flex -translate-x-1/2 items-center gap-3 rounded-lg border border-error bg-error-bg-strong px-4 py-2 shadow-lg"
    >
      <span className="text-sm text-error">{error}</span>
      <Button
        variant="icon"
        size="sm"
        icon="close"
        aria-label="Dismiss"
        onClick={clearError}
      />
    </div>
  );
}
